<template>
  <div id="readInfoList">
    <div class="background-white  first-title" >
      <span style="font-size:16px;font-weight:900">阅读信息查询</span>
      <!-- <el-select v-if="branchtypeLst.length>0"  v-model="branchtype" placeholder="请选择渠道" style="width:30%;float:right" @change="changeBranchtype()">
        <el-option  v-for="(branchtype,index) in branchtypeLst" :key="index" :label="branchtype.name" :value="branchtype.code"></el-option>
      </el-select> -->
    </div>
    <div class="item">
        <div class="item-title"  style="padding-right: 0;">汇总阅读信息查询
           <el-button type="primary" @click="exportCourseSummaryExcel()" class="search-btn">导出</el-button>
        </div>
        <div  class="background-white">
            <div class="title-now">
               <img src="../../../assets/train/dir.png"/>
            </div>
            <div style="float:left;line-height: 40px;">全部</div>

             <el-button type="primary" @click="getCourseSummaryWithPage(true)" style=" float: right;">查询</el-button>
              <div class="search-param">
              <el-input v-model="courseName" style="width:90%" placeholder="课程名称模糊查询"></el-input>

            </div>
        <div style="clear:both"></div>
        </div>
    </div>

    <div class="item">

        <div  class="background-white">
                <el-table
                  :data="tableData"
                  style="width: 100%">
                  <el-table-column
                    prop="courseName"
                    label="课程名"
                    >
                  </el-table-column>
                  <el-table-column
                    prop="sumPre"
                    label="浏览人数"
                    sortable
                    >
                  </el-table-column>
                  <el-table-column
                    prop="sumDownload"
                    label="下载人数"
                    sortable
                    align="center">
                  </el-table-column>
                  <el-table-column
                    prop="sumStart"
                    label="学习人数"
                    sortable
                    align="center">
                  </el-table-column>
                  <el-table-column
                    prop="sumFinish"
                    label="完成人数"
                    sortable
                    align="center">
                  </el-table-column>
                   <el-table-column
                    prop="sumDuration"
                    label="规定学习时长"
                    align="center">
                  </el-table-column>
                  <el-table-column
                    prop="sumFinish"
                    label="指定学习任务"
                    :formatter=getAssignStr
                    align="center">
                  </el-table-column>
                  <el-table-column
                    label="操作"
                    align="center"
                  >
                  <template slot-scope="scope">

                      <el-button type="text"    size="small"  @click="gotoDetail(scope.row.courseCode,scope.row.courseName)" >查看具体详情</el-button>
                  </template>
                  </el-table-column>
                </el-table>
                <div style="text-align:right">
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page.sync="currentPage"
                            :page-size="pageSize"
                            layout="total, prev, pager, next, jumper"
                            :page-sizes="[10, 20, 50]"
                            :total="records">
                    </el-pagination>
                </div>
        </div>
    </div>

  </div>
</template>

<script>
import api from '@/modules/api.js'

export default {
  data () {
    return {
      courseName: '',
      pageSize: 10,
      currentPage: 1,
      records: 0, // 总条数
      tableData: [],
      branchtypeLst: []
    }
  },
  mounted () {
    this.getBranchtypeLst()
  },
  methods: {
    getBranchtypeLst () {
      let that = this
      api.getBranchtypeLst({}, function (res) {
        if (res.result.isSuccess === true) {
          that.branchtypeLst = res.data
          that.branchtype = res.data[0].code
          that.courseName = ''
          that.getCourseSummaryWithPage()
        } else {
          that.$message.error(res.result.error)
        }
      })
    },
    getCourseSummaryWithPage (searchFlag) {
      let that = this
      that.req = {
        'branchtype': that.branchtype,
        'pageSize': that.pageSize
      }
      if (searchFlag) {
        // 点击了查询按钮
        that.currentPage = 1
        if (that.courseName !== '') {
          that.req.courseName = that.courseName
        }
      }
      that.req.page = that.currentPage
      api.getCourseSummaryWithPage(that.req, function (res) {
        if (res.result.isSuccess === true) {
          that.tableData = res.data.data
          that.records = res.data.records
        } else {
          that.$message.error(res.result.error)
        }
      })
    },
    exportCourseSummaryExcel () {
      let that = this

      api.exportCourseSummaryExcel(that.req, function (res) {
        if (res.result.isSuccess === true) {
          window.location.href = res.data.loadUrl
        } else {
          that.$message.error(res.result.error)
        }
      })
    },
    // 查询，每页条数更改
    handleSizeChange: function (size) {
      this.pageSize = size
      this.getCourseSummaryWithPage()
    },
    // 当前页数更改
    handleCurrentChange: function (currentPage) {
      this.currentPage = currentPage
      this.getCourseSummaryWithPage()
    },
    changeBranchtype () {
      this.currentPage = 1
      this.courseName = ''
      this.getCourseSummaryWithPage(true)
    },
    getAssignStr (row) {
      if (row.isAssigned != null) {
        if (row.isAssigned === 0) {
          return '是'
        } else if (row.isAssigned === 1) {
          return '否'
        }
      }
    },
    gotoDetail (courseCode, courseName) {
      this.$router.push({name: 'readDetailList', query: {courseCode: courseCode, branchtype: this.branchtype, courseName: courseName}})
    }
  },
  watch: {
    '$route': {
      deep: true,
      handler: function (newVal, oldVal) {
        if (newVal.name === 'readInfoList') {
          this.currentPage = 1
          this.getBranchtypeLst()
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
 .background-white{
   background-color: #fff;
   padding:10px 1%
 }
 .item{
   margin-top: 10px;
 }
 .item-title{
  background-color: #eee;
        padding: 5px 2%;
    height: 40px;
    line-height: 40px;
 }
 .search-btn{
    float: right;
    margin-right: 1%;

 }
 .search-param{
    float: right;
    width: 30%;
 }
 .title-now{
   float: left;
   margin: 10px 1% 0 2%
 }
 .title-now img{
    height: 20px;
 }
.first-title{
  padding: 10px 2%;
  height: 40px;
  line-height: 40px
}
</style>



// WEBPACK FOOTER //
// src/pages/course/backend/readInfoList.vue